import React from "react";
import InsuranceDashboardLayout from "../insurance-dashboard-layout/InsuranceDashboardLayout";
import PatientInfo from "./PatientInfo";
import PatientInfoApproved from "./PatientInfoApproved";
import Chat from "../chat/ChatModal";
import DoctorInfo from "./DoctorInfo";
import DoctorInfoApproved from "./DoctorInfoApproved";
import TestInfo from "./TestInfo";
import TestApproved from "./TestApproved";

const PatientInformation = () => {
  return (
    <>
      <InsuranceDashboardLayout>
        <PatientInfo />
        {/* <PatientInfoApproved/> */}
        {/* <Chat /> */}
        {/* <DoctorInfo /> */}
        {/* <DoctorInfoApproved /> */}
        {/* <TestInfo /> */}
        {/* <TestApproved /> */}
      </InsuranceDashboardLayout>
    </>
  );
};

export default PatientInformation;
